interface Props<NameType extends string> {
  isChecked: boolean;
  onChange: (name: NameType) => void;
  name: string;
  label: React.ReactNode;
}

const Checkbox = <T extends string>({
  isChecked,
  onChange,
  name,
  label,
}: Props<T>) => (
  <div
    className="group py-2 px-0 inline-flex items-start rounded-md"
  >
    <label htmlFor={name} className="custom-checkbox relative cursor-pointer">
      <input
        type="checkbox"
        id={name}
        checked={isChecked}
        onChange={() => onChange(name as T)}
        className="hidden-checkbox"
      />
      <div className="styled-checkbox mr-2 -mb-1" />
      <span className="text-sm text-charcoal font-bold leading-snug">
        {label}
      </span>
    </label>
  </div>
);

export { Checkbox };
